import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AutenticacionGuard } from '../../seguridad/guardias';
import { ContenedorComponent } from '../admin-lte3/componentes';
import {
  BandejaDetalleAprobarComponent,
  BandejaArchivadoComponent,
  BandejaDetalleArchivarComponent,
  BandejaBorradorComponent,
  BandejaDetalleDerivarComponent,
  BandejaDetalleVerComponent,
  BandejaEntradaComponent,
  BandejaEnviadoComponent,
  BandejaDetalleEnviarComponent,
  BandejaSalidaComponent
} from './componentes/bandeja';

import { BuzonListaComponent } from './componentes/buzon';
import { BuzonUsuarioListaComponent } from './componentes/buzon-usuario';
import { ClasificacionListaComponent } from './componentes/clasificacion';
import { ContactoListaComponent } from './componentes/contacto';
import {
  DocumentoArchivoCentralComponent,
  DocumentoArchivoCentralDetalleComponent,
  DocumentoArchivoComponent,
  DocumentoArchivoDetalleComponent
} from './componentes/documento';
import { ParametroListaComponent } from './componentes/parametro';
import {
  PlantillaListaComponent,
  PlantillaFormularioComponent
} from './componentes/plantilla';
import { TipoDocumentoListaComponent } from './componentes/tipo-documento';
import {
  GrupoListaComponent,
  GrupoFormularioComponent
} from './componentes/grupo';
import { GrupoBuzonListaComponent } from './componentes/grupo-buzon';
import {
  RolListaComponent,
  RolFormularioComponent
} from './componentes/rol';
import { UsuarioListaComponent } from './componentes/usuario';
import { CuentaListaComponent } from './componentes/cuenta';
import { VistaAreasMinerasListaComponent } from './componentes/vista-areas-mineras';
import { VistaServiciosRegistradosListaComponent, 
        VistaServiciosRegistradosHojaRutaComponent, 
        VistaServiciosRegistradosCptComponent, 
        VistaServiciosRegistradosImpresionHojaRutaComponent, 
        VistaServiciosRegistradosFormularioValidacionComponent,
        VistaServiciosRegistradosDocumentoOrdenServicioComponent
} from './componentes/vista-servicios-registrados';
import { VistaPatentesMinerasListaComponent } from './componentes/vista-patentes-mineras';
import { FormularioRecepcionListaComponent } from './componentes/formulario-recepcion';
import { GeneraCertificadoVigenciaListaComponent } from './componentes/genera-certificado-vigencia';
import { VistaPatentesMinerasInactivosListaComponent } from './componentes/vista-patentes-mineras-inactivos';
import { VistaAreasMinerasDigitalizacionListaComponent } from './componentes/vista-areas-mineras-digitalizacion';

const routes: Routes = [
  {
    path: '',
    component: ContenedorComponent,
    canActivate: [],
    children: [
      {
        path: 'correspondencia/tipos-documento',
        component: TipoDocumentoListaComponent,
        canActivate: [],
        data: {
          title: 'Administración de tipos de documento',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Tipos de documento' }
          ],
          roles: ['']
        }
      },
      {
        path: 'correspondencia/clasificaciones',
        component: ClasificacionListaComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Administración de clasificaciones',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Clasificaciones' }
          ],
          roles: ['CORRESPONDENCIA - ADMINISTRADOR']
        }
      },
      {
        path: 'correspondencia/contactos',
        component: ContactoListaComponent,
        canActivate: [],
        data: {
          title: 'Contactos externos',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Contactos' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/buzones',
        component: BuzonListaComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Buzones',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Buzones' }],
          roles: ['CORRESPONDENCIA - ADMINISTRADOR']
        }
      },
      {
        path: 'correspondencia/buzones/:buzonId/usuarios',
        component: BuzonUsuarioListaComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Buzones',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Buzones', url: '/correspondencia/buzones' },
            { title: 'Usuarios' }
          ],
          roles: ['CORRESPONDENCIA - ADMINISTRADOR']
        }
      },
      {
        path: 'correspondencia/plantillas',
        component: PlantillaListaComponent,
        canActivate: [],
        data: {
          title: 'Administración de plantillas',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Plantillas' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/plantillas/crear',
        component: PlantillaFormularioComponent,
        canActivate: [],
        data: {
          title: 'Creación de plantilla',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Plantillas', url: '/correspondencia/plantillas' },
            { title: 'Crear' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/plantillas/:id/modificar',
        component: PlantillaFormularioComponent,
        canActivate: [],
        data: {
          title: 'Modificación de plantilla',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Plantillas', url: '/correspondencia/plantillas' },
            { title: 'Modificar' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/parametros',
        component: ParametroListaComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Parámetros',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Parámetros' }],
          roles: ['CORRESPONDENCIA - ADMINISTRADOR']
        }
      },
      {
        path: 'correspondencia/grupos',
        component: GrupoListaComponent,
        canActivate: [],
        data: {
          title: 'Grupos',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Grupos' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/grupos/crear',
        component: GrupoFormularioComponent,
        canActivate: [],
        data: {
          title: 'Creación de Grupo',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Grupos', url: '/correspondencia/grupos' },
            { title: 'Crear' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/grupos/:id/modificar',
        component: GrupoFormularioComponent,
        canActivate: [],
        data: {
          title: 'Modificación de grupo',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Grupos', url: '/correspondencia/grupos' },
            { title: 'Modificar' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/grupos-buzon/:grupoId/buzones',
        component: GrupoBuzonListaComponent,
        canActivate: [],
        data: {
          title: 'Grupos',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Grupos', url: '/correspondencia/grupos' },
            { title: 'Buzones' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/bandeja-borradores',
        component: BandejaBorradorComponent,
        canActivate: [],
        data: {
          title: 'Bandeja de borradores',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Borradores' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/bandeja-entrada',
        component: BandejaEntradaComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Bandeja de entrada',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Entrada' }],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/bandeja-salida',
        component: BandejaSalidaComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Bandeja de salida',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Salida' }],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/bandeja-enviados',
        component: BandejaEnviadoComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Bandeja de enviados',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Enviados' }],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/bandeja-archivados',
        component: BandejaArchivadoComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Bandeja de archivados',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Archivados' }],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/documentos/:id/enviar',
        component: BandejaDetalleEnviarComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Enviar documento',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Documentos', url: '/correspondencia/documentos' },
            { title: 'Enviar' }
          ],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/documentos/:id/aprobar',
        component: BandejaDetalleAprobarComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Aprobar documento',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Documentos', url: '/correspondencia/documentos' },
            { title: 'Aprobar' }
          ],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/documentos/:id/derivar',
        component: BandejaDetalleDerivarComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Derivar documento',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Documentos', url: '/correspondencia/documentos' },
            { title: 'Derivar' }
          ],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/documentos/:id/detalle',
        component: BandejaDetalleVerComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Detalle de documento',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Documentos', url: '/correspondencia/documentos' },
            { title: 'Detalle de documento' }
          ],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/documentos/:id/archivado',
        component: BandejaDetalleArchivarComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Documento archivado',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Documentos', url: '/correspondencia/documentos' },
            { title: 'Documento archivado' }
          ],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/archivo',
        component: DocumentoArchivoComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Archivo',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Archivo' }],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/archivo/:id/detalle',
        component: DocumentoArchivoDetalleComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Detalle de documento',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Documentos', url: '/correspondencia/archivo' },
            { title: 'Detalle de documento' }
          ],
          roles: [
            'CORRESPONDENCIA - ADMINISTRADOR',
            'CORRESPONDENCIA - USUARIO'
          ]
        }
      },
      {
        path: 'correspondencia/archivo-central',
        component: DocumentoArchivoCentralComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Archivo central',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Archivo central' }
          ],
          roles: ['CORRESPONDENCIA - ARCHIVO CENTRAL']
        }
      },
      {
        path: 'correspondencia/archivo-central/:id/detalle',
        component: DocumentoArchivoCentralDetalleComponent,
        canActivate: [AutenticacionGuard],
        data: {
          title: 'Detalle de documento',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Documentos', url: '/correspondencia/archivo-central' },
            { title: 'Detalle de documento' }
          ],
          roles: ['CORRESPONDENCIA - ARCHIVO CENTRAL']
        }
      },
      {
        path: 'correspondencia/roles',
        component: RolListaComponent,
        canActivate: [],
        data: {
          title: 'Roles',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Roles' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/roles/crear',
        component: RolFormularioComponent,
        canActivate: [],
        data: {
          title: 'Creación de Rol',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Roles', url: '/correspondencia/roles' },
            { title: 'Crear' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/roles/:id/modificar',
        component: RolFormularioComponent,
        canActivate: [],
        data: {
          title: 'Modificación de rol',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Roles', url: '/correspondencia/roles' },
            { title: 'Modificar' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/usuarios',
        component: UsuarioListaComponent,
        canActivate: [],
        data: {
          title: 'Usuarios',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Usuarios' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/cuentas',
        component: CuentaListaComponent,
        canActivate: [],
        data: {
          title: 'Cuentas',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Cuentas' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-areas-mineras',
        component: VistaAreasMinerasListaComponent,
        canActivate: [],
        data: {
          title: 'Areas Mineras',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Areas Mineras' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-servicios-registrados',
        component: VistaServiciosRegistradosListaComponent,
        canActivate: [],
        data: {
          title: 'Servicios',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Servicios' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-patentes-mineras/:IdAreaMinera/patentes',
        component: VistaPatentesMinerasListaComponent,
        canActivate: [],
        data: {
          title: 'Patentes Mineras',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Areas Mineras', url: '/correspondencia/vistas-patentes-mineras' },
            { title: 'VistaPatentesMineras' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/formularios-recepciones',
        component: FormularioRecepcionListaComponent,
        canActivate: [],
        data: {
          title: 'Certificado de Pago de Patente Minera',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Formulario-Recepcion' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/genera-certificados-vigentes',
        component: GeneraCertificadoVigenciaListaComponent,
        canActivate: [],
        data: {
          title: 'Certificados',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Genera Certificados Vigentes' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-patentes-mineras-inactivos/:IdAreaMinera/patentes',
        component: VistaPatentesMinerasInactivosListaComponent,
        canActivate: [],
        data: {
          title: 'Patentes Mineras',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Areas Mineras', url: '/correspondencia/vistas-patentes-mineras-inactivos' },
            { title: 'VistaPatentesMinerasInactivos' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-areas-mineras-digitalizacion',
        component: VistaAreasMinerasDigitalizacionListaComponent,
        canActivate: [],
        data: {
          title: 'Areas Mineras',
          urls: [{ title: 'Inicio', url: '/inicio' }, { title: 'Areas Mineras' }],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-servicios-registrados/:IdSolicitud/hoja-ruta',
        component: VistaServiciosRegistradosHojaRutaComponent,
        canActivate: [],
        data: {
          title: 'Hoja Ruta Externa',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Orden de Servicio', url: '/correspondencia/vistas-servicios-registrados' },
            { title: 'VistaServiciosRegistrados' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-servicios-registrados/:IdSolicitud/cpt',
        component: VistaServiciosRegistradosCptComponent,
        canActivate: [],
        data: {
          title: 'CPT',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Orden de Servicio', url: '/correspondencia/vistas-servicios-registrados' },
            { title: 'VistaServiciosRegistrados' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-servicios-registrados/:IdSolicitud/impresion-hoja-ruta',
        component: VistaServiciosRegistradosImpresionHojaRutaComponent,
        canActivate: [],
        data: {
          title: 'Impresion Hoja Ruta',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Orden de Servicio', url: '/correspondencia/vistas-servicios-registrados' },
            { title: 'VistaServiciosRegistrados' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-servicios-registrados/:IdSolicitud/formulario-validacion',
        component: VistaServiciosRegistradosFormularioValidacionComponent,
        canActivate: [],
        data: {
          title: 'Formulario Validacion',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Orden de Servicio', url: '/correspondencia/vistas-servicios-registrados' },
            { title: 'VistaServiciosRegistrados' }
          ],
          roles: []
        }
      },
      {
        path: 'correspondencia/vistas-servicios-registrados/:IdSolicitud/documento-orden-servicio',
        component: VistaServiciosRegistradosDocumentoOrdenServicioComponent,
        canActivate: [],
        data: {
          title: 'Documento Orden Servicio',
          urls: [
            { title: 'Inicio', url: '/inicio' },
            { title: 'Orden de Servicio', url: '/correspondencia/vistas-servicios-registrados' },
            { title: 'VistaServiciosRegistrados' }
          ],
          roles: []
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CorrespondenciaRoutingModule {}
